import React, { useState, useEffect } from "react";
import Flexbox from "flexbox-react";
import axios from "axios";
import Cookies from "js-cookie";
import { FilledButton, OutlinedButton } from "../../buttons-20250224T111359Z-001/buttons";
import ToastStore from "../../../stores/ToastStore";
import { HTMLSelect } from "@blueprintjs/core";
const ManageProfileField = ({ userId }) => {
  const [profileTemplateList, setProfileTemplateList] = useState([]);
  const [currentSelectedTemplate, setCurrentSelectedTemplate] = useState(null);
  const [profileFields, setProfileFields] = useState([]);
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
//  const [uniqueIdentifier, setUniqueIdentifier] = useState("");

  useEffect(() => {
    fetchProfileTemplateList();
  }, []);

  useEffect(() => {
    if (currentSelectedTemplate?.id) {
      fetchProfileFields();
    }
  }, [currentSelectedTemplate]);

  const fetchProfileTemplateList = () => {
    axios.get(`${Cookies.get("apiEnv")}/fetch_profile_data/profile_template_list?user_id=${userId}`).then(response => {
      const templates = response.data.profile_template || [];
      const defaultTemplate = templates.find(t => t.default);
      const dropdownListTemplates = templates.filter(t => !t.default);

      setCurrentSelectedTemplate(defaultTemplate || null);
      setProfileTemplateList(dropdownListTemplates);
    });
  };

  const fetchProfileFields = () => {
    axios
      .get(`${Cookies.get("apiEnv")}/fetch_profile_data/element_minimal_data?profile_template_id=${currentSelectedTemplate.id}`)
      .then(response => {
        setProfileFields(response.data.elements);
        console.log("profile fields", response.data.elements);
        const initialFormData = {};
        response.data.elements?.forEach(field => {
          initialFormData[field.element_id] = field.external_field_name || "";
        });
        setFormData(initialFormData);
      })
      .catch(error => {
        console.error("Error fetching profile fields", error);
      });
  };

  const handleExternalFieldNameChange = (elementId, value) => {
    setFormData(prevData => ({
      ...prevData,
      [elementId]: value
    }));
  };

  const resetFormFields = () => {
    const clearedFormData = {};
    profileFields.forEach(field => {
      clearedFormData[field.element_id] = "";
    });
    setFormData(clearedFormData);
  };

  const handleSubmit = e => {
    e.preventDefault();
    const payload = {
      profile_settings: profileFields?.map(field => ({
        element_id: field.element_id,
        field_name: field.name,
        external_field_name: formData[field.element_id] || "",
        field_type: field.element_type,
        profile_template_id: currentSelectedTemplate.id,
        profile_master_detail_id: field.profile_master_detail_id,
       // unique_identifier_field: field.element_id === uniqueIdentifier ? 1 : 0
      }))
    };

    axios
      .post(`${Cookies.get("apiEnv")}/fetch_profile_data/profile_template_filed`, payload)
      .then(response => {
        fetchProfileFields();

        ToastStore.showToast("Successfully Submitted", "success");
      })
      .catch(error => {
        ToastStore.showToast("Something went wrong in Submission: Try again!", "danger");
        console.log("Error submitting goal rating:", error);
      });
  };

  const handleSyncProfile = () => {
    setLoading(true);
    axios
      .get(`${Cookies.get("apiEnv")}/fetch_profile_data/fetch_bamboo_data?user_id=${userId}`)
      .then(response => {
        ToastStore.showToast("Profile synced successfully!", "success");
        fetchProfileFields();
      })
      .catch(error => {
        ToastStore.showToast("Failed to sync profile: Try again!", "danger");
        console.error("Error syncing profile:", error);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <Flexbox flexDirection="column" width="100%">
      <Flexbox flexDirection="row" alignItems="center" justifyContent="space-between">
        <h2 style={{ marginBottom: "20px" }}>Manage Profile Fields</h2>
        {currentSelectedTemplate && (
          <select
            value={currentSelectedTemplate?.id || ""}
            onChange={e => {
              const selectedId = e.target.value;
              const selectedTemplate = [...profileTemplateList, currentSelectedTemplate].find(t => t.id === selectedId);
              setCurrentSelectedTemplate(selectedTemplate);
            }}
            style={{
              padding: "8px",
              borderRadius: "4px",
              border: "1px solid #ccc",
              backgroundColor: "#fff"
            }}
          >
            <option key={currentSelectedTemplate?.id} value={currentSelectedTemplate.id}>
              {currentSelectedTemplate?.name}
            </option>
            {profileTemplateList.map(template => (
              <option key={template.id} value={template.id}>
                {template.name}
              </option>
            ))}
          </select>
        )}
      </Flexbox>
      {profileFields.length > 0 && (
        <Flexbox flexDirection="row" justifyContent="flex-end" className=" push-30-b">

         {/* <FilledButton   text={loading ? "Syncing..." : "Sync Profile"}
            onClick={handleSyncProfile}
            disabled={loading}   >

          </FilledButton> */}
          {/* <FilledButton text='Edit' ></FilledButton>
        <OutlinedButton text='Reset' onClick={resetFormFields} ></OutlinedButton> */}

          {/* <Flexbox flexDirection="row"  alignItems="center" width="65%">
            <label style={{ fontWeight: "bold", width: "260px" }}>Select Unique Identifier:</label>
            <select
              value={uniqueIdentifier}
              onChange={e => setUniqueIdentifier(e.target.value)}
              style={{
                flex: 1,
                padding: "8px",
                borderRadius: "4px",
                border: "1px solid #ccc",
                backgroundColor: "#fff",
                width: "100%"               
              }}      
            >
              <option value="">Select Unique Identifier</option>
              {profileFields.map(field => (
                <option key={field.element_id} value={field.element_id}>
            
                  {field.name}
                </option>
              ))}
            </select>
          </Flexbox> */}

          {/* <p style={{ fontSize: "12px", color: "#666", marginTop: "5px" }}>
            The unique identifier acts as a primary key to uniquely identify users, you can skip this.
          </p> */}
        </Flexbox>
      )}

      {profileFields && profileFields?.length === 0 ? (
        <p>Nothing to show ...</p>
      ) : (
        <form style={{ width: "65%" }}>
          {profileFields.map(field => (
            <div
              key={field.element_id}
              style={{
                marginBottom: "15px",
                display: "flex",
                flexDirection: "row",
                alignItems: "center"
              }}
            >
              <label
                style={{
                  fontWeight: "bold",
                  // whiteSpace: 'nowrap',
                  minWidth: "250px",
                  wordWrap: "break-word",
                  width: "260px"
                }}
              >
                {field.name}
              </label>
              <input
                type="text"
                placeholder="Enter External Field Name"
                value={formData[field.element_id] ?? ""}
                onChange={e => handleExternalFieldNameChange(field.element_id, e.target.value)}
                style={{
                  flex: 1,
                  padding: "8px",
                  borderRadius: "4px",
                  border: "1px solid #ccc"
                }}
              />
            </div>
          ))}
          <FilledButton text={"Save"} onClick={e => handleSubmit(e)} />
        </form>
      )}
    </Flexbox>
  );
};

export default ManageProfileField;
